// flow weak

  import React, { Component }     from 'react';
  import PropTypes                    from 'prop-types';
  import AnimatedView                 from '../../../components';
  import styles                       from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                                   from '../../../services/fetchTools';
  import { Spinner }                  from 'react-activity';

  import BulkPauseSubscription        from '../bulkPauseSubscription';
  import ExtendPause                  from '../extendPause';
  
  
  class BulkPause extends Component {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = { 
        pause_sub: true,
        extend_pause: false,
        court_booking: false
      };
      this.handleSelection = this.handleSelection.bind(this);
    }

    handleSelection(event) {
      const name = event.target.name;
      if(name === 'pause_sub'){
        this.setState({pause_sub:true,extend_pause:false,court_booking:false})
      }
      else if(name === 'extend_pause'){
        this.setState({extend_pause:true,pause_sub:false,court_booking:false})
      }
      else if(name === 'court_booking'){
        this.setState({court_booking:true,extend_pause:false,pause_sub:false})
      }

    }
  
    render() {
      console.log('here is the data',this.state)
      return(
        <div>
          <button className='button1' style={{marginRight:'1%',backgroundColor:'rgb(122, 101, 149)'}} name='pause_sub' onClick={this.handleSelection}> Pause Subscriptions </button>
          <button className='button1' style={{marginRight:'1%',backgroundColor:'rgb(122, 101, 149)'}} name='extend_pause' onClick={this.handleSelection}> Extend Pause </button>
          <button className='button1' style={{marginRight:'1%',backgroundColor:'rgb(122, 101, 149)'}} name='court_booking' onClick={this.handleSelection}> Pause Court Booking </button>

          {
            this.state.pause_sub &&
            <BulkPauseSubscription/>
          }
          {
            this.state.extend_pause && 
            <ExtendPause/>
          }
        </div>
      );
    }
  }
  
  export default BulkPause;
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/bulkPause/BulkPause.js